export const createMockEntitiesArray = (length) => {
  return [...new Array(length).keys()].map((item) => ({ id: `id-${item}` }));
};
